import React from 'react';
import { compose } from 'redux';
import ContainerSize from '../../../ContainerSize';
import SelectableDeviationWrapper from '../SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import GallectionDeviationControlButtons from '../GallectionDeviationControlButtons';
import CustomSetDeviationControlButtons from '../CustomSetDeviationControlButtons';
import TierDeviationControlButtons from '../TierDeviationControlButtons';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import IndicatorForDeviationThumb from '../IndicatorForDeviationThumb';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './ManageableDeviation.scss';
const enhance = compose(withSelectedDeviations, withCurrentMediaSource);
class ManageableDeviation extends React.Component {
    render() {
        const { deviation, selectedDeviations, currentMediaSource } = this.props;
        let ControlButtons;
        switch(currentMediaSource){
            case MediaSourceType.CUSTOM_SET:
                ControlButtons = CustomSetDeviationControlButtons;
                break;
            case MediaSourceType.TIER_DEVIATIONS:
            case MediaSourceType.TIER_POSTS:
                ControlButtons = TierDeviationControlButtons;
                break;
            case MediaSourceType.PRIVATE_COLLECTION:
            case MediaSourceType.COLLECTION:
            case MediaSourceType.GALLERY:
            case MediaSourceType.STASH:
                ControlButtons = GallectionDeviationControlButtons;
                break;
            default:
                return null;
        }
        const isAnySelected = !!selectedDeviations.length;
        return /*#__PURE__*/ React.createElement(ContainerSize, {
            className: s['measured-container']
        }, ({ width, height })=>/*#__PURE__*/ React.createElement(SelectableDeviationWrapper, {
                key: getDeviationEntityId(deviation),
                deviation: deviation,
                className: s['deviation-wrapper']
            }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
                deviation: deviation,
                width: width,
                height: height
            }), /*#__PURE__*/ React.createElement(IndicatorForDeviationThumb, {
                deviation: deviation,
                className: s['indicator']
            }), !isAnySelected && /*#__PURE__*/ React.createElement("div", {
                className: s['control-buttons'],
                onClick: this.onControlButtonsWrapperClick
            }, /*#__PURE__*/ React.createElement(ControlButtons, {
                deviation: deviation
            }))));
    }
    onControlButtonsWrapperClick(event) {
        event.stopPropagation();
    }
}
export default enhance(ManageableDeviation);

//# sourceMappingURL=ManageableDeviation.js.map